import { render, staticRenderFns } from "./NewInsight.vue?vue&type=template&id=b28e3842&scoped=true&"
import script from "./NewInsight.vue?vue&type=script&lang=js&"
export * from "./NewInsight.vue?vue&type=script&lang=js&"
import style0 from "./NewInsight.vue?vue&type=style&index=0&id=b28e3842&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28e3842",
  null
  
)

export default component.exports